<template>
<div>
  <template v-if="isShowBasicMessage">
  <pt-sub-title title="基本信息"></pt-sub-title>
  <div :class="$style['basic-message']">
    <wt-table v-if="canApprovalUsers.length>0" :labels="tableLabels" :list="canApprovalUsers">
    </wt-table>
  </div>
  </template>
  <pt-sub-title title="审核操作" v-if="!refundDialog||!showRefund"></pt-sub-title>
  <review-opretion v-model="form" ref="form" :auditState="auditStatus" :selectTab="selectTab" :userType="userType" :auditAlreadyRefund="auditAlreadyRefund"
  :isBatch="isBatch" :isRefundReject="isRefundReject" :rejectMethods="rejectMethods" :isRefund="isRefund" :isRefundCompleted="isRefundCompleted"
  :refundDialog="refundDialog"></review-opretion>
  <div class="button-div">
        <el-button type="primary" @click="submit" :loading="submitLoading">确认</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
  </div>
</div>
</template>
<script>
import { awardTableLabel, awardRadios } from './award-audit'
import { manualRewardLabels } from 'cps/new-to-old-audit/pt-manual-reward/manual-reward-option'
import reviewOpretion from './review-opretion'
export default {
  computed: {
    tableLabels () {
      return this.isManualReward ? manualRewardLabels : awardTableLabel
    },
    formValue () {
      return this.$refs.form
    },
    // 是否显示基本信息
    isShowBasicMessage () {
      return this.fromPage !== 'detail' && this.isManualReward
    }
  },
  props: {
    userType: {
      type: String,
      default: null
    },
    selectTab: {
      type: String,
      default: null
    },
    selectRows: {
      type: Array,
      default: function () {
        return []
      }
    },
    statisticsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isBatch: {
      type: Boolean,
      default: false
    },
    isManualReward: {
      type: Boolean,
      default: false
    },
    auditStatus: {
      type: String,
      default: null
    },
    auditAlreadyRefund: {
      type: Boolean
    },
    refundDialog: {
      type: Boolean
    },
    fromPage: {
      type: String
    }
  },
  components: {
    reviewOpretion
  },
  data () {
    return {
      awardTableLabel: awardTableLabel,
      awardRadios: awardRadios,
      form: {
        ids: []
      },
      submitLoading: false,
      canApprovalUsers: [],
      ids: [],
      rejectMethods: null,
      isRefundReject: false,
      isRefund: false,
      showRefund: false,
      isRefundCompleted: false
    }
  },
  watch: {
    selectRows: {
      handler: function (val) {
        this.showRefund = val[0].showRefund
        val.forEach(item => {
          if (item.status === 'WAITING_FOR_APPROVAL' || item.status === 'SALES_COMPLETED' || item.status === 'REJECTED') {
            this.canApprovalUsers.push(item)
          }
        })
        if (val[0] && val[0].extendInformation && val[0].extendInformation.customerBringNew &&
          val[0].extendInformation.customerBringNew.finalRewardCount === '第一轮' && val[0].businessType === 'CUSTOMER_BRING_NEW_QJK') {
          this.isRefund = true
          if (val[0].status === 'COMPLETED') {
            this.isRefundCompleted = true
          } else {
            this.isRefundReject = true
          }
          this.refundMethod(val[0].id)
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取退款方式
    refundMethod (id) {
      this.$store.dispatch('refundMethod', id).then(res => {
        this.rejectMethods = res
      }).catch(err => {
        this.$message.error(err || '获取驳回方式失败')
      })
    },
    submit () {
      this.formValue.validate().then(formValue => {
        this.form.ids = this.form.ids || []
        this.selectRows.forEach(item => {
          if (item.status === 'WAITING_FOR_APPROVAL' || item.status === 'SALES_COMPLETED' || item.status === 'REJECTED' ||
         this.isRefund) {
            this.form.ids.push(item.id)
          }
          if (this.form.status === 'remindPay' && item.extendInformation.userType === 'OLD') {
            this.ids.push(item.id)
          }
        })
        let data = JSON.parse(JSON.stringify(this.form))
        if (this.form.status === 'remindPay') {
          this.$confirm('系统将仅向选中的老用户发放催费通知', '催费提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning' }).then(_ => {
            this.$delete(data, 'status')
            this.oldCudtomerRemindPay()
          })
        } else if (this.refundDialog
        //  || (this.isRefundReject && this.form.status === 'REJECTED')
        ) {
          this.$delete(data, 'status')
          this.refundBringNewReward(data)
        } else if (this.form.status === 'REJECTED') {
          // else {
          this.$delete(data, 'status')
          this.rejectByBatchBringNew(data)
          // }
        } else {
          this.$delete(data, 'status')
          this.approvalByBatchBringNew(data)
        }
      })
    },
    refundBringNewReward (data) {
      this.submitLoading = true
      this.$store.dispatch('refundBringNewReward', data).then(res => {
        this.$emit('closeDialog', true)
        this.$message.success('驳回奖励记录成功')
        this.submitLoading = false
      }).catch(err => {
        this.$message.error(err || '驳回奖励记录失败')
        this.submitLoading = false
      })
    },
    oldCudtomerRemindPay () {
      let data = {
        ids: this.ids
      }
      this.$store.dispatch('oldCudtomerRemindPay', data).then(res => {
        this.$emit('closeDialog')
        this.$message.success('催费通知发送成功')
      }).catch(err => {
        this.$message.error(err || '催费通知发送失败')
      })
    },
    approvalByBatchBringNew (data) {
      this.submitLoading = true
      let apiUrl
      if (this.selectTab === 'SALES_COMPLETED' || this.auditStatus === 'SALES_COMPLETED') {
        apiUrl = this.isManualReward ? 'batchManualRewardApprove' : 'approvalByBatchBringNew'
      } else {
        apiUrl = this.isManualReward ? 'batchManualRewardApproveSaler' : 'approvalByBatchBringNewSaler'
      }
      this.$store.dispatch(apiUrl, data).then(res => {
        this.$emit('closeDialog', true, res.showResult, res)
        this.$message.success('审核成功')
        this.submitLoading = false
      }).catch(err => {
        this.submitLoading = false
        this.$message.error(err || '审核奖励失败')
      })
    },
    rejectByBatchBringNew (data) {
      this.submitLoading = true
      let apiUrl
      if (this.selectTab === 'SALES_COMPLETED' || this.auditStatus === 'SALES_COMPLETED') {
        apiUrl = this.isManualReward ? 'batchManualRewardReject' : 'rejectByBatchBringNew'
      } else {
        apiUrl = this.isManualReward ? 'batchManualRewardRejectSaler' : 'rejectByBatchBringNewSaler'
      }
      this.$store.dispatch(apiUrl, data).then(res => {
        this.$message.success('审核成功')
        this.submitLoading = false
        this.$emit('closeDialog', true)
      }).catch(err => {
        this.submitLoading = false
        this.$message.error(err || '审核奖励失败')
      })
    },
    cancel () {
      this.$emit('closeDialog')
    }
  },
  created () {
  }

}
</script>
<style module lang="less">
.basic-message{
  padding: 0 20px
}
</style>
